module.exports = __webpack_public_path__ + "static/img/get_chocolate.896d30fd.png";